import { render, staticRenderFns } from "./unused--view_BookEditor.vue?vue&type=template&id=55744ba2&scoped=true&"
import script from "./unused--view_BookEditor.vue?vue&type=script&lang=js&"
export * from "./unused--view_BookEditor.vue?vue&type=script&lang=js&"
import style0 from "./unused--view_BookEditor.vue?vue&type=style&index=0&id=55744ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55744ba2",
  null
  
)

export default component.exports